import React, {useState} from 'react';
import './ChoosePersonStep.scss';
import ChoseTypePerson from "./ChoseTypePerson";
import CheckNationalId from "./CheckNationalId";
import AddLegalPerson from "./AddPesonForms/AddLegalPerson";
import AddRealPerson from "./AddPesonForms/AddRealPerson";
import AddRealOrganizePerson from "./AddPesonForms/AddRealOrganizePerson";

const ChoosePersonStep = ({sendData, setSendData}) => {

  const [openAddForm, setOpenAddForm] = useState(false)

  return (
    <div className={"choose-person-step"}>
      <ChoseTypePerson sendData={sendData} setSendData={setSendData}/>
      {openAddForm && <button className={"go-back"} onClick={() => setOpenAddForm(false)}>بازگشت</button>}
      {!openAddForm ?
        <CheckNationalId sendData={sendData} setSendData={setSendData} setOpenAddForm={setOpenAddForm}/> :
        sendData?.personType === "legal" ?
          <AddLegalPerson sendData={sendData} setSendData={setSendData}/> :
          sendData?.personType === "real" ?
            <AddRealPerson sendData={sendData} setSendData={setSendData}/> :
            sendData?.personType === "real-organize" ?
              <AddRealOrganizePerson sendData={sendData} setSendData={setSendData}/> : <></>
      }
    </div>
  );
};

export default ChoosePersonStep;